import React, { useState } from 'react'
import arrowBelow from '../../assets/img/icon/arrow-below.png';
import arrowRight from '../../assets/img/icon/arrow-right.svg';
import { FiHome } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { SlHome } from "react-icons/sl";

const ProductSubHeading = ({ heading, heading2 }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const handleMobileNavToggle = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const handleMobileNavItemClick = (item) => {
        setIsMobileNavOpen(false);
        // Handle navigation based on item
        navigate(`/${item}`);
    };

    return (
        <>
            {/* Page Header */}
            <div className={`page-header ${isMobileNavOpen ? 'mobile-menu-open' : ''}`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item">상조의전</span>
                    <span className="breadcrumb-separator">|</span>
                    <span className={`breadcrumb-item ${heading && !heading2 ? 'active' : ''}`}>{heading}</span>
                    {heading2 && (
                        <>
                            <span className="breadcrumb-separator">|</span>
                            <span className="breadcrumb-item active">{heading2}</span>
                        </>
                    )}

                </div>

                <div className="mobile-navigation-section">
                    <img src={arrowBelow} alt="mobile-nav-icon" onClick={handleMobileNavToggle} className={isMobileNavOpen ? 'active' : ''} />
                </div>

            </div>

            {/* Mobile Navigation */}
            {isMobileNavOpen && (
                <div className="mobile-navigation">

                    <div className="mobile-nav-items">
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('mutual-assistance-product-info')
                                || location.pathname.includes('event-procedure')
                                || location.pathname.includes('service-advantages') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('mutual-assistance-product-info')}
                        >
                            <span>상품안내</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('opening-relocation') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('opening-relocation')}
                        >
                            <span>개장/이장</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('general-funeral-procedures')
                                || location.pathname.includes('funeral-information-religious')
                                || location.pathname.includes('funeral-methods')
                                || location.pathname.includes('funeral-information-other') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('general-funeral-procedures')}
                        >
                            <span>장례정보</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                    </div>

                </div>
            )}
        </>
    )
};

export default ProductSubHeading;




